<script setup lang="ts">
import BaseButton from "@/core/components/base/BaseButton.vue";
import {
    Dialog,
    DialogContent,
    DialogFooter,
    DialogHeader,
    DialogTitle,
    DialogTrigger
} from "@/core/components/ui/dialog";
import {AutoCompleteSearchbar} from "@/auto-complete-searchbar/components/searchbar";
import {ref, watch} from "vue";
import {
    SearchBarAutoCompleteItem
} from "@/auto-complete-searchbar/interfaces/ISearchBarAutoComplete";
import AutoCompleteSearchBarProductDatatable
    from "@/auto-complete-searchbar/components/searchbar/AutoCompleteSearchBarProductDatatable.vue";
import LaboratoryProduct from "@/core/interfaces/laboratory/LaboratoryProduct";
import {loyaltyCardApi} from "@/container";

const emits = defineEmits<{
    (e: 'included'): void;
}>();

const props = defineProps<{
    loyaltyCardId: string | number
}>();

const items = ref<SearchBarAutoCompleteItem[]>([]);
const productIds = ref<number[]>([]);
const loadingProducts = ref(false);
const open = ref(false);
const tableProduct = ref<LaboratoryProduct[]>([]);
const loadInclusion = ref(false);

watch(open, (value) => {
    if (value) {
        items.value = [];
        productIds.value = [];
    }
});

/**
 * Include the selected products in the loyalty card
 */
const include = () => {
    loadInclusion.value = true;

    loyaltyCardApi()
        .includeProducts(props.loyaltyCardId, productIds.value)
        .then(() => {
            emits('included');
            open.value = false;
        })
        .finally(() => {
            loadInclusion.value = false;
        });
};
</script>

<template>
  <Dialog v-model:open="open">
    <DialogTrigger as-child>
      <BaseButton primary density="comfortable">
        Ajouter un produit
      </BaseButton>
    </DialogTrigger>
    <DialogContent class="flex flex-col max-h-[80dvh]" @interact-outside="(e) => e.preventDefault()">
      <DialogHeader class="p-0">
        <DialogTitle>
          Ajouter un produit au programme de fidélité
        </DialogTitle>
      </DialogHeader>
      <div class="space-y-4">
        <AutoCompleteSearchbar
          v-model:selected-items="items"
        />
        <AutoCompleteSearchBarProductDatatable
          v-model:selected="productIds"
          :items="items"
          @product-loaded="products => tableProduct = products"
        />
      </div>
      <DialogFooter>
        <BaseButton
          density="comfortable"
          primary
          :loading="loadingProducts"
          :disabled="!productIds?.length"
          @click="include"
        >
          Valider la sélection de {{ productIds?.length }} produit{{ productIds?.length > 1 ? 's' : '' }}
        </BaseButton>
      </DialogFooter>
    </DialogContent>
  </Dialog>
</template>
